import LessonPlayer from "./LessonPlayer";

function LessonIndex() {
  return (
    <>
      <LessonPlayer />
    </>
  );
}

export default LessonIndex;
